var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRemove = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "56px",
    height: "56px",
    viewBox: "0 0 56 56",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Atom/icons/annuler small") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "path-1",
    cx: 29,
    cy: 29,
    r: 28
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "CNC---Cuisine",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Search",
    transform: "translate(-1116.000000, -30.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(747.000000, 28.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Atom/icons/annuler-small",
    transform: "translate(369.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1.000000, -1.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2-Copy"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun_print_1049500"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Color/grey1",
    opacity: 0.200000003,
    mask: "url(#mask-2)",
    fill: "#5F7081"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 58,
    height: 58
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M37.3776796,34.0419484 C38.3174615,34.9957002 38.306588,36.5309195 37.3528259,37.4701734 C36.8806049,37.9356581 36.2654749,38.1681416 35.6513805,38.1681416 C35.0248592,38.1681416 34.3988557,37.9268559 33.9245636,37.4453199 L29.2696659,32.7231613 L24.4537367,37.4701734 C23.9809979,37.9356581 23.3663857,38.1681416 22.7517736,38.1681416 C22.1257701,38.1681416 21.4997666,37.9268559 21.0249567,37.4453199 C20.0851748,36.492086 20.0965661,34.9568666 21.0498104,34.0170949 L25.8657396,29.2700829 L21.1176404,24.4536882 C20.1778585,23.4999364 20.1892498,21.9652349 21.1424941,21.0249454 C22.0957385,20.0856915 23.6309745,20.0960471 24.5707564,21.0497989 L29.3183378,25.8661935 L34.0421011,21.2103109 C34.9958632,20.2710569 36.5305814,20.2819303 37.4703633,21.2351643 C38.4101452,22.1883983 38.3992717,23.7236176 37.4460274,24.6633893 L32.7222641,29.319272 L37.3776796,34.0419484 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgRemove);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/remove.0ef3451ee82762c54cfa1857b85e3657.svg";